export default "__VITE_ASSET__XiHjk5Nz__"